import React from 'react';

import IMG_CARD from 'assets/tags/Client-Card-Jen.svg';
import IMG_BACKGROUND from 'assets/tags/header-background.svg';
import IMG_SPARKLE from 'assets/tags/sparkle-light.png';
import IMG_MAP from 'assets/tags/Tag-Image-No-show-risk.svg';
import S from 'constants/string.const';

import CN from './ClientTagsSplashTopPanel.module.scss';

const ClientTagsSplashTopPanel = () => (
  <section data-bem="ClientTagsSplashTopPanel" className={CN.topContainer}>
    <div data-bem="ClientTagsSplashTopPanel__column" className={CN.column}>
      <div data-bem="ClientTagsSplashTopPanel__col" className={CN.col}>
        <div data-bem="ClientTagsSplashTopPanel__text" className={CN.texEmoji}>
          <span className={CN.emoji} role="img" aria-labelledby="megaphone">
            {S.megaphone}
          </span>
          {S.space}new feature
        </div>
        <h3 data-bem="ClientTagsSplashTopPanel__title" className={CN.title}>
          Client Tags
        </h3>
        <h5 className={CN.subTitle}>
          Putting inclusivity at the{S.space}
          <span className={CN.emojiHeart} role="img" aria-labelledby="Heart">
            {S.heartSlick}
          </span>
          {S.space}of your business.
        </h5>
        <div data-bem="ClientTagsSplashTopPanel__text" className={CN.texEmoji}>
          <span className={CN.emoji} role="img" aria-labelledby="Star">
            {S.star}
          </span>
          {S.space}Add tags to client record cards to show preferences or needs
        </div>
        <div data-bem="ClientTagsSplashTopPanel__text" className={CN.texEmoji}>
          <span className={CN.emoji} role="img" aria-labelledby="Star">
            {S.star}
          </span>
          {S.space}Visable to staff on bookings and checkouts
        </div>
        <div data-bem="ClientTagsSplashTopPanel__text" className={CN.texEmoji}>
          <span className={CN.emoji} role="img" aria-labelledby="Star">
            {S.star}
          </span>
          {S.space}Not visable to clients on receipts or client facing screens
        </div>
        <div data-bem="ClientTagsSplashTopPanel__text" className={CN.texEmoji}>
          Access client tags and more by upgrading to the Advanced plan.
        </div>
      </div>
      <div data-bem="ClientTagsSplashTopPanel__col" className={CN.col}>
        <img
          src={IMG_SPARKLE}
          className={CN.imgSparkle}
          alt="Sparkle"
          data-bem="ClientTagsSplashTopPanel__img-sparkle"
        />

        <div data-bem="ClientTagsSplashTopPanel__imgMap" className={CN.imgMap}>
          <img src={IMG_MAP} alt="Graphics map description" />
        </div>
        <div data-bem="ClientTagsSplashTopPanel__imgCard" className={CN.imgCard}>
          <img src={IMG_CARD} alt="Card description" />
        </div>
      </div>
    </div>
    <img src={IMG_BACKGROUND} alt="background" className={CN.imgBackground} />
  </section>
);
export default ClientTagsSplashTopPanel;
